import { render, staticRenderFns } from "./TrainYdRight.vue?vue&type=template&id=f10e9d6e&scoped=true&"
import script from "./TrainYdRight.vue?vue&type=script&lang=js&"
export * from "./TrainYdRight.vue?vue&type=script&lang=js&"
import style0 from "./TrainYdRight.vue?vue&type=style&index=0&id=f10e9d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e9d6e",
  null
  
)

export default component.exports